import { PcpCommandBarModule } from './../../../../../pcpcommandbar/pcp-commandbar.module';
import { ListboxModule } from 'primeng/listbox';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecordableNotificationsComponent } from './recordable.notifications.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ErrormessageModule } from './../../../../../validation/errormessage/errormessage.module';

@NgModule({
    imports: [
        CheckboxModule,
        CommonModule,
        SelectModule,
        ErrormessageModule,
        FormsModule,
        ToggleSwitchModule,
        ListboxModule,
        MultiSelectModule,
        PcpCommandBarModule,        
        RecordableNotificationsComponent
    ],
    exports: [RecordableNotificationsComponent]
})
export class RecordableNotificationsModule { }
